import { SpSadtRequestedProcedure } from "../../models/private-billing/sp-sadt-requested-procedure.model";
import { ProcedureStruct } from "./procedure.struct";

export class SpSadtRequestedProcedureStruct extends SpSadtRequestedProcedure {
    public idProcedure: number;
    public idTerminologyGroup: number;
    public procedureHealthcareIsActive: boolean;
    public terminologyGroupCode: string;
    public procedure: ProcedureStruct;
}